let StatusValue; // uses template literal types to get the string representation of the values of the FieldsMap enums

(function (StatusValue) {
  StatusValue["Info"] = "info";
  StatusValue["Success"] = "success";
  StatusValue["Warning"] = "warning";
  StatusValue["Critical"] = "critical";
  StatusValue["Attention"] = "attention";
  StatusValue["New"] = "new";
})(StatusValue || (StatusValue = {}));

let ProgressValue;

(function (ProgressValue) {
  ProgressValue["Incomplete"] = "incomplete";
  ProgressValue["PartiallyComplete"] = "partiallyComplete";
  ProgressValue["Complete"] = "complete";
})(ProgressValue || (ProgressValue = {}));

export { ProgressValue, StatusValue };
